import {useQuery} from 'react-query';
import {LayerDetailVO, UserLayersApi} from '../api';
import {FeatureId} from '@mc/react-mapio';
import {useMapioContext} from '../mapioContext';

export const CACHE_KEY_LAYER_DETAIL = 'CACHE_KEY_LAYER_DETAIL';

export const useLayerDetail = (layerId: number, featureId: FeatureId) => {
    const mapioContext = useMapioContext();
    return useQuery<LayerDetailVO>(
        [CACHE_KEY_LAYER_DETAIL, layerId, featureId],
        async () => (await UserLayersApi.getLayerDetail(layerId, featureId as string, undefined, mapioContext.value?.context)).data,
        {
            enabled: Boolean(layerId && featureId),
            refetchOnWindowFocus: true,
        },
    );
};
